export const environment = {
  production: true,
  serverEndpoint: 'https://vb-lxp-bk-app-sro.vbricklab.com/',
};
